// aiArtifactPersist — pure guard för I-001:s "skapa artifact_version vid
// Apply"-flöde. Returnerar request-payloaden om meta är komplett, annars
// null (och Index.tsx hoppar tyst, utan DB-write).

import type { Intent } from '@/lib/intentTypes';
import type { WorkflowState } from '@/types/workflow';

export interface AiProposalMeta {
  conversationId?: string;
  intent?: Intent;
  promptMessageId?: string;
}

export interface ArtifactPersistRequest {
  conversationId: string;
  artifactId: string | null;
  operation: Intent;
  content: WorkflowState;
  promptMessageId?: string;
  title?: string;
}

/**
 * Returnera payload:en till `useArtifactMutations().createVersion(...)`
 * när meta är komplett (har både conversationId OCH intent). Saknas
 * något av dem är intentionen "direkt import utan conversation-kontext"
 * → ingen version ska skapas.
 */
export function buildArtifactPersistRequest(
  meta: AiProposalMeta | null | undefined,
  approved: WorkflowState,
): ArtifactPersistRequest | null {
  if (!meta) return null;
  if (!meta.conversationId) return null;
  if (!meta.intent) return null;
  return {
    conversationId: meta.conversationId,
    artifactId: null,
    operation: meta.intent,
    content: approved,
    promptMessageId: meta.promptMessageId,
    title: approved.name,
  };
}
